export const BOOK = {
  id: "ebook_end_of_the_obvious",
  title: "The End of the Obvious",
  subtitle: "Signals · Perception · The Menu · The Long Clock",
  author: "From the Archives of the Gg Elves",
  price: 3.33,
  originalPrice: 9.99,
  currency: "$",
  pages: 154,
  chapters: 4,
};

export const MARQUEE_ITEMS = [
  "THE END OF THE OBVIOUS",
  "SIGNALS · PERCEPTION · THE MENU · THE LONG CLOCK",
  "FROM THE ARCHIVES OF THE GG ELVES",
  "154 PAGES OF ILLUMINATION",
  "INSTANT PDF DOWNLOAD + EMAIL LINK",
  "LIMITED TIME — $3.33",
];

export const EXCERPTS = [
  {
    id: "signals",
    tab: "The Signals",
    chapter: "Chapter I",
    page: "p. 5",
    quotes: [
      { text: "A signal is simply something that asks to be noticed.", page: "p. 6" },
      {
        text: "Perhaps the strangest signal is that human beings are more connected than ever — and still feel alone.",
        page: "p. 7",
      },
      { text: "The internet made affinity into a place.", page: "p. 8" },
    ],
    note: "Learning to distinguish true noise from ancient resonance — the small tremors that arrive before the earthquake of change.",
  },
  {
    id: "perception",
    tab: "The Art of Perception",
    chapter: "Chapter II",
    page: "p. 40",
    quotes: [
      { text: "What happens when perception itself becomes part of the evolution?", page: "p. 42" },
      {
        text: "This filtering is not necessarily a defect. It may be one of the reasons human beings can function at all.",
        page: "p. 43",
      },
      {
        text: "The problem is no longer simply: Can we access information? The problem becomes: What are we capable of recognising?",
        page: "p. 53",
      },
    ],
    note: "Your filters shape your reality long before your choices do. This chapter re-architects the instrument through which you see.",
  },
  {
    id: "menu",
    tab: "The Dish Is Not the Menu",
    chapter: "Chapter III",
    page: "p. 78",
    quotes: [
      { text: "The menu is not the dish.", page: "p. 80" },
    ],
    note: "Models, beliefs, feeds, and symbols are descriptions of reality — not reality itself. The most dangerous mistake of the modern mind is eating the menu.",
  },
  {
    id: "clock",
    tab: "The Long Clock",
    chapter: "Chapter IV",
    page: "p. 111",
    quotes: [
      {
        text: "Perhaps the problem was never the amount of time. Perhaps it was the speed of the clock we agreed to live inside.",
        page: "p. 125",
      },
      { text: "Nothing new can grow in a life that never pauses.", page: "p. 131" },
      {
        text: "Perhaps this is why some ancient things are returning. Not necessarily because everything ancient was better. It wasn't.",
        page: "p. 122",
      },
    ],
    note: "Stepping off the fast clock of the feed and back onto the slow clock of seasons, craft, and deep time.",
  },
];

export const INSIDE_ITEMS = [
  {
    number: "I",
    name: "The Signals",
    pages: "pp. 5–39",
    desc: "A signal is simply something that asks to be noticed. Learn to read the subtle indicators of change in culture, technology, and yourself.",
  },
  {
    number: "II",
    name: "The Art of Perception",
    pages: "pp. 40–77",
    desc: "How your frame of reference dictates your reality — and how to rebuild the lens in an age of hyper-saturation.",
  },
  {
    number: "III",
    name: "The Dish Is Not the Menu",
    pages: "pp. 78–110",
    desc: "Why consuming symbols will never satisfy the hunger for experience — and how to return to the dish itself.",
  },
  {
    number: "IV",
    name: "The Long Clock",
    pages: "pp. 111–143",
    desc: "Perhaps the problem was never the amount of time. Perhaps it was the speed of the clock we agreed to live inside.",
  },
];

export const TESTIMONIALS = [
  {
    quote: "I read it in one sitting, then immediately read it again. Something in me got quietly rearranged.",
    name: "Mara V.",
    role: "Early reader",
  },
  {
    quote: "The chapter on the Long Clock alone is worth ten times the price. I think about it every single day.",
    name: "J. Okafor",
    role: "Designer & writer",
  },
  {
    quote: "It doesn't tell you what to think. It teaches you how to see. That is a far rarer gift.",
    name: "Elena R.",
    role: "Early reader",
  },
];

export const FAQS = [
  {
    q: "How do I receive the book after buying?",
    a: "Instantly. The moment your payment completes you get a download button on screen, plus an email with your personal download link so you can return to it anytime.",
  },
  {
    q: "What format is the book?",
    a: "A beautifully typeset 154-page PDF (Reader's Edition). It reads perfectly on phone, tablet, e-reader, and desktop — no special app required.",
  },
  {
    q: "Why is it $3.33 instead of $9.99?",
    a: "This is a limited early-reader offer from the Archive. The price returns to $9.99 once the offer window closes.",
  },
  {
    q: "Is my payment secure?",
    a: "Yes. Checkout is fully encrypted and your card details never touch our servers.",
  },
];

export const IMAGES = {
  parchment:
    "https://images.unsplash.com/photo-1595232208179-d8cf4ca455fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxvbGQlMjBwYXJjaG1lbnQlMjBpbmslMjBtYW51c2NyaXB0JTIwdGV4dHVyZSUyMGRhcmslMjBwYXBlcnxlbnwwfHx8fDE3OTE5NTgxNDd8MA&ixlib=rb-4.1.0&q=85",
  rings:
    "https://images.unsplash.com/photo-1774385439741-6d11ad44f984?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxteXN0aWNhbCUyMGdvbGRlbiUyMGNvbmNlbnRyaWMlMjByaW5ncyUyMGNlbGVzdGlhbCUyMGFzdHJvbm9teSUyMGRhcmslMjBhZXN0aGV0aWN8ZW58MHx8fHwxNzkxOTU4MTQxfDA&ixlib=rb-4.1.0&q=85",
};
